// extracted by mini-css-extract-plugin
export default {"page":"styles-module__page__rWNbgiR","subnav":"styles-module__subnav__prKlqbC"};